import React, { Component } from 'react';
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import * as galleryActions from "../../actions/gallery";

import MainLayout from "../common/MainLayout";

class Graphics extends Component {

    constructor(props) {
        super(props);
        this.state = {
            gal_type: 'MY_UPLOADS'
        };
    }


    componentWillMount() {

        let data = {"type" : this.state.gal_type};
        this.props.setGalleryType(data);
    }
    render() {

        return (
            <MainLayout pageName="MY_UPLOADS" />
        );
    }
}

function mapStateToProps(state) {

    return {
        galleryUpdate  :state.gallery.galleryUpdate
    };

}
export default  withRouter(connect(mapStateToProps, {
    setGalleryType : galleryActions.setType
})(Graphics));



// WEBPACK FOOTER //
// ./src/components/gallery/Graphics.js